import React from "react";

import { CONTACT_DETAILS } from "../../data/content";

const styles = {
  button: {
    position: "fixed",
    right: 18,
    bottom: 18,
    zIndex: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "#25d366",
    color: "#ffffff",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.25)",
  },
  icon: {
    width: 32,
    height: 32,
    fill: "currentColor",
  },
};

//Floating WhatsApp chat button, as on the original site
const WhatsAppButton = () => {
  return (
    <a
      href={CONTACT_DETAILS.WHATSAPP_LINK}
      style={styles.button}
      target={"_blank"}
      rel={"noopener noreferrer"}
      aria-label={"Chat to us on WhatsApp"}
    >
      <svg
        viewBox={"0 0 24 24"}
        style={styles.icon}
        aria-hidden={"true"}
      >
        <path d={"M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.8h-.01a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.72.97 1-3.62-.24-.37a9.78 9.78 0 0 1-1.5-5.23c0-5.41 4.41-9.82 9.83-9.82 2.62 0 5.09 1.02 6.94 2.88a9.76 9.76 0 0 1 2.87 6.95c0 5.41-4.41 9.82-9.81 9.82zm8.36-18.18A11.73 11.73 0 0 0 12.05.16C5.54.16.24 5.46.24 11.97c0 2.08.54 4.11 1.58 5.9L.14 24l6.27-1.64a11.8 11.8 0 0 0 5.64 1.44h.01c6.51 0 11.81-5.3 11.81-11.81 0-3.16-1.23-6.12-3.46-8.36z"} />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
